/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AuditInputs */

const cs_nav_audit = /** @type {(inputs: Nav_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditní log`)
};

const en_nav_audit = /** @type {(inputs: Nav_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit log`)
};

/**
* | output |
* | --- |
* | "Audit log" |
*
* @param {Nav_AuditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_audit = /** @type {((inputs?: Nav_AuditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AuditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_audit(inputs)
	return cs_nav_audit(inputs)
});